export enum AppTimeSeriesCubeMetric {
    TimeInApp = 'TimeInApp', // Total duration
    Interactions = 'Interactions', // count
    AvgDuration = 'AvgDuration', // total duration / count
    CallTimeInApp = 'CallTimeInApp', // total call duration
    CallInteractions = 'CallInteractions', // call count
    CallAvgDuration = 'CallAvgDuration', // total call duration / call count
    TotalMeetingDuration = 'TotalMeetingDuration', // total meeting duration
    TotalMeetingCount = 'TotalMeetingCount', // meeting count
    AvgMeetingDuration = 'AvgMeetingDuration', // total meeting duration / meeting count
  }